import { render } from "./PaymentModal.vue?vue&type=template&id=6ac3d95b&scoped=true"
import script from "./PaymentModal.vue?vue&type=script&lang=js"
export * from "./PaymentModal.vue?vue&type=script&lang=js"

import "./PaymentModal.vue?vue&type=style&index=0&id=6ac3d95b&lang=scss&scoped=true"

import exportComponent from "/Users/hou/Desktop/zijie/sdxlxh_user/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ac3d95b"]])

export default __exports__